import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FixtureForm, OutcomeType } from '@cds/betting-offer/add-ons';
import { FixtureOutcome } from '@cds/statistics/fixture';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { LastEventsStatistics, StatisticsModel, TeamType } from '../statistics/statistics.models';

@Component({
    selector: 'ms-last-matches-performance',
    templateUrl: 'last-matches-performance.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LastMatchesPerformanceComponent {
    @Input() set statistics(value: StatisticsModel | FixtureForm) {
        this.lastEventsStatistics = this.mapToLastEventsStatistics(value);
    }

    @Input() teamType: TeamType;
    @Input() showEventDates = true;
    lastMatchTeams = TeamType;
    lastEventsStatistics: LastEventsStatistics | undefined;

    constructor(public sitecore: Sitecore) {}

    private mapToLastEventsStatistics(value: StatisticsModel | FixtureForm): LastEventsStatistics | undefined {
        if (!value) {
            return undefined;
        }
        if (this.isStatisticModel(value)) {
            return {
                home:
                    value.lastMatches?.home?.map((lastEvent) => ({
                        fixtureOutcome: lastEvent.fixtureOutcome,
                        dateOfEvent: lastEvent.dateOfEvent,
                    })) || [],
                away:
                    value.lastMatches?.away?.map((lastEvent) => ({
                        fixtureOutcome: lastEvent.fixtureOutcome,
                        dateOfEvent: lastEvent.dateOfEvent,
                    })) || [],
            };
        } else {
            const fixtureForm = value as FixtureForm;

            return {
                home: fixtureForm.overallHomeTeamForm?.outcomes?.map((outcome) => ({ fixtureOutcome: this.mapOutcome(outcome) })) || [],
                away: fixtureForm.overallAwayTeamForm?.outcomes?.map((outcome) => ({ fixtureOutcome: this.mapOutcome(outcome) })) || [],
            };
        }
    }

    private mapOutcome(outcome: OutcomeType): FixtureOutcome {
        switch (outcome) {
            case OutcomeType.Draw:
                return FixtureOutcome.Draw;
            case OutcomeType.Lost:
                return FixtureOutcome.Lost;
            case OutcomeType.Won:
                return FixtureOutcome.Won;
            default:
                return FixtureOutcome.Unknown;
        }
    }

    private isStatisticModel(value: StatisticsModel | FixtureForm): value is StatisticsModel & boolean {
        return 'lastMatches' in value;
    }
}
